import { z } from "zod";
import { rpc } from "./rpc";
import { bookingSchema, createBookingResultSchema, slotSchema, studioSchema } from "./schemas";

export const publicApi = {
  studio: (slug: string) => rpc("get_public_studio", { p_slug: slug }, studioSchema),

  slots: (slug: string, serviceId: string, from: string, days: number) =>
    rpc("get_available_slots", { p_slug: slug, p_service_id: serviceId, p_from: from, p_days: days }, z.array(slotSchema)),

  /** Price, duration and studio are resolved by the server from the slug and service id. */
  createBooking: (input: {
    slug: string;
    serviceId: string;
    startsAt: string;
    name: string;
    phone: string;
    email?: string;
    comment?: string;
    idempotencyKey: string;
  }) =>
    rpc(
      "create_booking",
      {
        p_slug: input.slug,
        p_service_id: input.serviceId,
        p_starts_at: input.startsAt,
        p_customer_name: input.name,
        p_customer_phone: input.phone,
        p_customer_email: input.email || null,
        p_comment: input.comment || null,
        p_idempotency_key: input.idempotencyKey,
      },
      createBookingResultSchema,
    ),

  booking: (token: string) => rpc("get_booking_by_token", { p_token: token }, bookingSchema),

  cancel: (token: string) => rpc("cancel_booking_by_token", { p_token: token, p_idempotency_key: null }, bookingSchema),

  reschedule: (token: string, startsAt: string, idempotencyKey: string) =>
    rpc(
      "reschedule_booking_by_token",
      { p_token: token, p_new_starts_at: startsAt, p_idempotency_key: idempotencyKey },
      bookingSchema.extend({ replayed: z.boolean() }),
    ),

  savePush: (token: string, sub: PushSubscriptionJSON) =>
    rpc(
      "save_push_subscription_by_token",
      { p_token: token, p_endpoint: sub.endpoint, p_p256dh: sub.keys?.p256dh, p_auth: sub.keys?.auth },
      z.object({ subscribed: z.boolean() }),
    ),

  deletePush: (token: string, endpoint: string) =>
    rpc("delete_push_subscription_by_token", { p_token: token, p_endpoint: endpoint }, z.object({ subscribed: z.boolean() })),
};
